import type { SiteConfig } from '../../@types/context/site-config.types';

export const organisationAxoNoConfig: Pick<SiteConfig, 'organisation'> = {
  organisation: {
    name: 'Axo Finans AS',
    number: '998543320',
    address: {
      streetAddress: 'St. Olavs gate 28',
      addressLocality: 'Oslo',
      postalCode: '0166',
      addressCountry: 'NO',
    },
  },
};
